module.exports = __webpack_public_path__ + "img/burst.791c2006.svg";